import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { svgAsPngUri } from "save-svg-as-png";
import { saveQrTemplate, saveVisualizationPost } from "../redux/requests";
import useCurrentLocation from "./useCurrentLocation";
import useLocalStorageQrConfigs from "./useLocalStorageQrConfigs";
import { designTypes } from "../constants/common";

const useSaveVisualization = () => {
  const dispatch = useDispatch();
  const { isGenerator, entryLocation } = useCurrentLocation();
  const { setLocalConfigs } = useLocalStorageQrConfigs();
  const { id, link, qrFrames, qrSettings, qrText, qrOptions, designType } =
    useSelector(
      (state) => ({
        id: state.getQrLinkSlice.id,
        link: state.getQrLinkSlice.link,
        qrFrames: state.qrFrames,
        qrSettings: state.qrSettings,
        qrText: state.qrText,
        qrOptions: state.qrOptions,
        designType: state.customizeQr.designType,
      }),
      shallowEqual
    );

  async function saveVisualisation() {
    const isBaseDesign = designType === designTypes.base;

    const excludedSettingsForArtQr = new Set([
      "qrBackgroundColor",
      "patternBackgroundTransparent",
      "logotype",
      "logotypeSize",
      "logotypeMargin",
      "logotypeBackground",
      "isSingleColorBackground",
      "gradientBackground",
    ]);

    const excludedSettingsForBaseQr = new Set([
      "backgroundImage",
      "backgroundImageSize",
    ]);

    const qrProperties = {
      link,
      designType,
      ...(isBaseDesign && {
        qrFrames: {
          frame: qrFrames.frame,
          frameColor: qrFrames.frameColor,
          frameTextColor: qrFrames.frameTextColor,
          frameTextToggle: qrFrames.frameTextToggle,
          frameTextFont: qrFrames.frameTextFont,
        },
        qrText: {
          frameText: qrText.frameText,
          ...(qrText.textSize !== -1 && { textSize: qrText.textSize }),
        },
        qrOptions: {
          ...qrOptions,
        },
      }),
      qrSettings: Object.fromEntries(
        Object.entries(qrSettings).filter(([key, value]) => {
          const excluded = isBaseDesign
            ? excludedSettingsForBaseQr
            : excludedSettingsForArtQr;
          return !excluded.has(key) && value !== undefined;
        })
      ),
    };

    if (!isGenerator && !entryLocation) {
      window.top !== window.self && setLocalConfigs(qrProperties);
      return;
    }
    const svgElement = document.querySelector("#svgQrWrapper");
    const svgCopy = svgElement.cloneNode(true);
    await svgAsPngUri(svgCopy);
    const dataImage = await svgAsPngUri(svgCopy, {
      scale: 1.2,
      encoderOptions: 1,
    });
    if (id)
      await dispatch(saveVisualizationPost([id, dataImage, qrProperties]));
  }

  const saveTemplateVisualisation = async (savedTemplatesSaveUrl) => {
    await dispatch(
      saveQrTemplate({
        data: { qrFrames, qrSettings, qrText, qrOptions, designType },
        savedTemplatesSaveUrl,
      })
    );
  };

  return { saveVisualisation, saveTemplateVisualisation };
};
export default useSaveVisualization;
